import React, { useState } from 'react';
import Icon from '../../components/AppIcon';

const RECON_STATES = ['Todos', 'Pendiente', 'Sugerida', 'Conciliada', 'Parcial', 'Ignorada', 'Incidencia'];
const RECON_STATE_COLORS = {
  'Pendiente': '#FBBF24',
  'Sugerida': '#60A5FA',
  'Conciliada': '#34D399',
  'Parcial': '#A78BFA',
  'Ignorada': 'rgba(255,255,255,0.30)',
  'Incidencia': '#F87171',
};

const accounts = [
  { bank: 'Banco Principal', iban: 'ES** **** **** **** **** 0001', holder: 'Las Dos Doncellas SL', type: 'Cuenta Corriente', balance: '—', available: '—', credit: '—', sync: 'Pendiente', status: 'pending', color: '#D6EF4E' },
  { bank: 'Banco Secundario', iban: 'ES** **** **** **** **** 0002', holder: 'Las Dos Doncellas SL', type: 'Cuenta Corriente', balance: '—', available: '—', credit: '—', sync: 'Pendiente', status: 'pending', color: '#60A5FA' },
  { bank: 'Cuenta Autónomo', iban: 'ES** **** **** **** **** 0003', holder: 'Titular Autónomo', type: 'Cuenta Personal', balance: '—', available: '—', credit: '—', sync: 'Pendiente', status: 'pending', color: '#34D399' },
];

const reconRuleTypes = [
  { label: 'Por proveedor', icon: 'Building2', color: '#60A5FA' },
  { label: 'Por cliente', icon: 'UserCircle', color: '#34D399' },
  { label: 'Por concepto', icon: 'FileText', color: '#FBBF24' },
  { label: 'Por importe', icon: 'DollarSign', color: '#A78BFA' },
  { label: 'Por IBAN', icon: 'CreditCard', color: '#D6EF4E' },
  { label: 'Por recurrencia', icon: 'RefreshCw', color: '#F87171' },
  { label: 'Por departamento', icon: 'Layers', color: '#60A5FA' },
];

const FinBancos = () => {
  const [reconState, setReconState] = useState('Todos');
  const [selectedAccount, setSelectedAccount] = useState(null);
  const [showImportModal, setShowImportModal] = useState(false);
  const [showRuleModal, setShowRuleModal] = useState(false);

  return (
    <div className="min-h-screen px-4 py-6 md:px-8"
      style={{ background: 'linear-gradient(135deg, #0A0A0A 0%, #111111 50%, #0D0D0D 100%)' }}>
      {/* Breadcrumb */}
      <div className="flex items-center gap-2 mb-5 text-xs font-oranienbaum text-white/30">
        <Icon name="Home" size={12} />
        <span>/</span>
        <span className="text-[#D6EF4E]/60">Finanzas Corporativas</span>
        <span>/</span>
        <span className="text-white/50">Bancos y Conciliación</span>
      </div>
      {/* Header */}
      <div className="flex flex-col md:flex-row md:items-center justify-between gap-4 mb-6">
        <div className="flex items-center gap-3">
          <div className="w-10 h-10 rounded-xl flex items-center justify-center flex-shrink-0"
            style={{ background: 'rgba(96,165,250,0.12)', border: '1px solid rgba(96,165,250,0.25)' }}>
            <Icon name="Landmark" size={20} className="text-[#60A5FA]" />
          </div>
          <div>
            <h1 className="font-oranienbaum font-bold text-white text-2xl tracking-wide">Bancos y Conciliación</h1>
            <p className="font-oranienbaum text-white/40 text-xs">Gestión multicuenta · Conciliación bancaria · Open Banking</p>
          </div>
        </div>
        <div className="flex items-center gap-2 flex-wrap">
          <button onClick={() => setShowImportModal(true)}
            className="flex items-center gap-2 px-4 py-2 rounded-xl text-xs font-oranienbaum font-semibold text-black transition-all hover:opacity-90"
            style={{ background: '#D6EF4E' }}>
            <Icon name="Upload" size={14} />
            Importar Extracto
          </button>
          <button className="flex items-center gap-2 px-3 py-2 rounded-xl text-xs font-oranienbaum text-white/60 hover:text-white transition-colors"
            style={{ background: 'rgba(255,255,255,0.04)', border: '1px solid rgba(255,255,255,0.08)' }}>
            <Icon name="Plus" size={13} />
            Añadir Cuenta
          </button>
        </div>
      </div>
      {/* Security notice */}
      <div className="mb-5 p-3 rounded-xl flex items-start gap-3"
        style={{ background: 'rgba(248,113,113,0.04)', border: '1px solid rgba(248,113,113,0.15)' }}>
        <Icon name="Shield" size={15} className="text-[#F87171]/70 flex-shrink-0 mt-0.5" />
        <div>
          <p className="font-oranienbaum text-[#F87171]/80 text-xs font-semibold mb-0.5">Seguridad bancaria</p>
          <p className="font-oranienbaum text-white/35 text-xs leading-relaxed">
            No se almacenan credenciales bancarias. La sincronización se realiza mediante proveedor autorizado de open banking con consentimiento seguro.
            Acceso de solo lectura. IBAN enmascarado en todo momento.
          </p>
        </div>
      </div>
      {/* Supabase notice */}
      <div className="mb-6 p-3 rounded-xl flex items-center gap-3"
        style={{ background: 'rgba(214,239,78,0.04)', border: '1px solid rgba(214,239,78,0.12)' }}>
        <Icon name="Info" size={15} className="text-[#D6EF4E]/60 flex-shrink-0" />
        <p className="font-oranienbaum text-white/40 text-xs">
          <span className="text-[#D6EF4E]/70 font-semibold">Pendiente de conexión con Supabase.</span>{' '}
          Los movimientos bancarios y saldos se mostrarán cuando se complete la integración.
        </p>
      </div>
      {/* Accounts Grid */}
      <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-8">
        {accounts?.map((acc, i) => (
          <div key={i}
            onClick={() => setSelectedAccount(selectedAccount === i ? null : i)}
            className={`rounded-2xl p-5 cursor-pointer transition-all hover:scale-[1.01] ${selectedAccount === i ? 'ring-1' : ''}`}
            style={{
              background: 'rgba(255,255,255,0.03)',
              border: `1px solid ${selectedAccount === i ? acc?.color + '40' : 'rgba(255,255,255,0.08)'}`,
              ringColor: acc?.color,
            }}>
            <div className="flex items-start justify-between mb-4">
              <div className="flex items-center gap-2">
                <div className="w-9 h-9 rounded-xl flex items-center justify-center"
                  style={{ background: `${acc?.color}15`, border: `1px solid ${acc?.color}25` }}>
                  <Icon name="Landmark" size={16} style={{ color: acc?.color }} />
                </div>
                <div>
                  <p className="font-oranienbaum font-bold text-white/80 text-sm">{acc?.bank}</p>
                  <p className="font-oranienbaum text-white/35 text-[10px]">{acc?.type}</p>
                </div>
              </div>
              <span className="px-2 py-0.5 rounded-full text-[9px] font-oranienbaum uppercase tracking-wider"
                style={{ background: 'rgba(251,191,36,0.12)', border: '1px solid rgba(251,191,36,0.25)', color: '#FBBF24' }}>
                {acc?.status === 'pending' ? 'Sin conectar' : 'Conectado'}
              </span>
            </div>
            <p className="font-oranienbaum text-white/30 text-[10px] mb-3 font-mono">{acc?.iban}</p>
            <div className="grid grid-cols-3 gap-2 mb-3">
              {[
                { label: 'Saldo', value: acc?.balance },
                { label: 'Disponible', value: acc?.available },
                { label: 'Crédito', value: acc?.credit },
              ]?.map((item) => (
                <div key={item?.label} className="text-center p-2 rounded-lg"
                  style={{ background: 'rgba(255,255,255,0.03)' }}>
                  <p className="font-oranienbaum text-white/25 text-[9px] uppercase tracking-wider">{item?.label}</p>
                  <p className="font-oranienbaum text-white/55 text-xs font-semibold mt-0.5">{item?.value}</p>
                </div>
              ))}
            </div>
            <div className="flex items-center justify-between">
              <p className="font-oranienbaum text-white/25 text-[10px]">Titular: {acc?.holder}</p>
              <div className="flex items-center gap-1">
                <div className="w-1.5 h-1.5 rounded-full bg-[#FBBF24]/50" />
                <span className="font-oranienbaum text-white/25 text-[10px]">{acc?.sync}</span>
              </div>
            </div>
            {selectedAccount === i && (
              <div className="mt-3 pt-3 border-t border-white/8 flex flex-wrap gap-1.5">
                {['Ver movimientos', 'Importar extracto', 'Conciliar', 'Configurar']?.map((action) => (
                  <button key={action} className="px-2 py-1 rounded-lg text-[10px] font-oranienbaum text-white/50 hover:text-white/80 transition-colors"
                    style={{ background: 'rgba(255,255,255,0.05)', border: '1px solid rgba(255,255,255,0.08)' }}>
                    {action}
                  </button>
                ))}
              </div>
            )}
          </div>
        ))}
      </div>
      {/* Reconciliation section */}
      <div className="grid grid-cols-1 xl:grid-cols-3 gap-6">
        {/* Movements table */}
        <div className="xl:col-span-2">
          <div className="flex items-center justify-between mb-4">
            <div className="flex items-center gap-2">
              <Icon name="GitMerge" size={15} className="text-[#D6EF4E]" />
              <h2 className="font-oranienbaum font-semibold text-white/70 text-sm">Movimientos Bancarios</h2>
            </div>
            <button onClick={() => setShowRuleModal(true)}
              className="flex items-center gap-2 px-3 py-1.5 rounded-lg text-xs font-oranienbaum text-white/50 hover:text-white/80 transition-colors"
              style={{ background: 'rgba(255,255,255,0.04)', border: '1px solid rgba(255,255,255,0.08)' }}>
              <Icon name="Zap" size={12} />
              Crear regla
            </button>
          </div>

          {/* State filter */}
          <div className="flex flex-wrap gap-1.5 mb-4">
            {RECON_STATES?.map((s) => (
              <button key={s} onClick={() => setReconState(s)}
                className={`px-3 py-1.5 rounded-lg text-[10px] font-oranienbaum transition-all ${reconState === s ? 'font-semibold' : 'text-white/40 hover:text-white/70'}`}
                style={reconState === s
                  ? { background: `${RECON_STATE_COLORS?.[s] || '#D6EF4E'}20`, border: `1px solid ${RECON_STATE_COLORS?.[s] || '#D6EF4E'}40`, color: RECON_STATE_COLORS?.[s] || '#D6EF4E' }
                  : { background: 'rgba(255,255,255,0.03)', border: '1px solid rgba(255,255,255,0.06)' }}>
                {s}
              </button>
            ))}
          </div>

          {/* Table */}
          <div className="rounded-2xl overflow-hidden"
            style={{ background: 'rgba(255,255,255,0.02)', border: '1px solid rgba(255,255,255,0.07)' }}>
            <div className="overflow-x-auto">
              <table className="w-full">
                <thead>
                  <tr style={{ background: 'rgba(255,255,255,0.04)', borderBottom: '1px solid rgba(255,255,255,0.07)' }}>
                    {['Fecha', 'Concepto', 'Importe', 'Saldo', 'Estado', 'Documento', 'Acciones']?.map((col) => (
                      <th key={col} className="px-3 py-3 text-left">
                        <span className="font-oranienbaum text-white/40 text-[10px] uppercase tracking-wider">{col}</span>
                      </th>
                    ))}
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td colSpan={7} className="px-4 py-16 text-center">
                      <div className="flex flex-col items-center gap-3">
                        <div className="w-12 h-12 rounded-2xl flex items-center justify-center"
                          style={{ background: 'rgba(255,255,255,0.04)', border: '1px solid rgba(255,255,255,0.08)' }}>
                          <Icon name="Landmark" size={22} className="text-white/20" />
                        </div>
                        <p className="font-oranienbaum text-white/30 text-sm">Pendiente de conexión con Supabase</p>
                        <p className="font-oranienbaum text-white/20 text-xs">Importa un extracto CSV o conecta tu banco para ver los movimientos</p>
                        <button onClick={() => setShowImportModal(true)}
                          className="mt-2 px-4 py-2 rounded-xl text-xs font-oranienbaum font-semibold text-black"
                          style={{ background: '#D6EF4E' }}>
                          <Icon name="Upload" size={12} className="inline mr-1" />
                          Importar extracto
                        </button>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>

        {/* Right panel: Rules + Stats */}
        <div className="space-y-4">
          {/* Reconciliation stats */}
          <div className="rounded-2xl p-4"
            style={{ background: 'rgba(255,255,255,0.025)', border: '1px solid rgba(255,255,255,0.07)' }}>
            <div className="flex items-center gap-2 mb-3">
              <Icon name="PieChart" size={14} className="text-[#D6EF4E]" />
              <h3 className="font-oranienbaum font-semibold text-white/70 text-sm">Estado Conciliación</h3>
            </div>
            <div className="space-y-2">
              {Object.entries(RECON_STATE_COLORS)?.filter(([k]) => k !== 'Todos')?.map(([state, color]) => (
                <div key={state} className="flex items-center justify-between py-1.5 border-b border-white/5 last:border-0">
                  <div className="flex items-center gap-2">
                    <div className="w-2 h-2 rounded-full" style={{ background: color }} />
                    <span className="font-oranienbaum text-white/50 text-xs">{state}</span>
                  </div>
                  <span className="font-oranienbaum text-white/30 text-xs">—</span>
                </div>
              ))}
            </div>
          </div>

          {/* Reconciliation rules */}
          <div className="rounded-2xl p-4"
            style={{ background: 'rgba(255,255,255,0.025)', border: '1px solid rgba(255,255,255,0.07)' }}>
            <div className="flex items-center justify-between mb-3">
              <div className="flex items-center gap-2">
                <Icon name="Zap" size={14} className="text-[#FBBF24]" />
                <h3 className="font-oranienbaum font-semibold text-white/70 text-sm">Reglas Automáticas</h3>
              </div>
              <button onClick={() => setShowRuleModal(true)}
                className="text-[10px] font-oranienbaum text-[#D6EF4E]/60 hover:text-[#D6EF4E] transition-colors">
                + Nueva
              </button>
            </div>
            <div className="space-y-1.5">
              {reconRuleTypes?.map((rule, i) => (
                <div key={i} className="flex items-center gap-2 px-3 py-2 rounded-xl"
                  style={{ background: 'rgba(255,255,255,0.02)', border: '1px solid rgba(255,255,255,0.05)' }}>
                  <Icon name={rule?.icon} size={12} style={{ color: rule?.color }} />
                  <span className="font-oranienbaum text-white/45 text-xs">{rule?.label}</span>
                  <span className="ml-auto font-oranienbaum text-white/20 text-[10px]">0 reglas</span>
                </div>
              ))}
            </div>
          </div>

          {/* Open banking info */}
          <div className="rounded-2xl p-4"
            style={{ background: 'rgba(96,165,250,0.04)', border: '1px solid rgba(96,165,250,0.15)' }}>
            <div className="flex items-center gap-2 mb-2">
              <Icon name="Wifi" size={14} className="text-[#60A5FA]" />
              <h3 className="font-oranienbaum font-semibold text-[#60A5FA]/80 text-sm">Open Banking</h3>
            </div>
            <p className="font-oranienbaum text-white/35 text-xs leading-relaxed mb-3">
              Sincronización segura mediante proveedor autorizado PSD2. Consentimiento renovable. Solo lectura.
            </p>
            <div className="space-y-1.5">
              {['Consentimiento seguro PSD2', 'Solo lectura', 'Sin credenciales almacenadas', 'Revocación inmediata', 'Registro de sincronizaciones']?.map((item) => (
                <div key={item} className="flex items-center gap-2">
                  <Icon name="Check" size={11} className="text-[#34D399]" />
                  <span className="font-oranienbaum text-white/40 text-[10px]">{item}</span>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
      {/* Import Modal */}
      {showImportModal && (
        <div className="fixed inset-0 z-50 flex items-center justify-center p-4">
          <div className="absolute inset-0 bg-black/70" onClick={() => setShowImportModal(false)} />
          <div className="relative w-full max-w-md rounded-2xl p-6"
            style={{ background: '#1A1A1A', border: '1px solid rgba(214,239,78,0.20)' }}>
            <div className="flex items-center justify-between mb-4">
              <h3 className="font-oranienbaum font-bold text-white text-lg">Importar Extracto Bancario</h3>
              <button onClick={() => setShowImportModal(false)} className="text-white/40 hover:text-white transition-colors">
                <Icon name="X" size={18} />
              </button>
            </div>
            <div className="space-y-3 mb-4">
              {['CSV estándar', 'Excel (.xlsx)', 'Formato OFX/QIF', 'Formato MT940']?.map((format) => (
                <button key={format} className="w-full flex items-center gap-3 px-4 py-3 rounded-xl text-left hover:bg-white/5 transition-colors"
                  style={{ background: 'rgba(255,255,255,0.03)', border: '1px solid rgba(255,255,255,0.08)' }}>
                  <Icon name="FileText" size={15} className="text-[#D6EF4E]/60" />
                  <span className="font-oranienbaum text-white/65 text-sm">{format}</span>
                  <Icon name="ChevronRight" size={13} className="ml-auto text-white/25" />
                </button>
              ))}
            </div>
            <div className="h-24 rounded-xl flex flex-col items-center justify-center gap-2 cursor-pointer hover:bg-white/5 transition-colors"
              style={{ background: 'rgba(255,255,255,0.02)', border: '2px dashed rgba(214,239,78,0.20)' }}>
              <Icon name="Upload" size={20} className="text-[#D6EF4E]/40" />
              <p className="font-oranienbaum text-white/30 text-xs">Arrastra el archivo aquí o haz clic para seleccionar</p>
            </div>
          </div>
        </div>
      )}
      {/* Rule Modal */}
      {showRuleModal && (
        <div className="fixed inset-0 z-50 flex items-center justify-center p-4">
          <div className="absolute inset-0 bg-black/70" onClick={() => setShowRuleModal(false)} />
          <div className="relative w-full max-w-md rounded-2xl p-6"
            style={{ background: '#1A1A1A', border: '1px solid rgba(251,191,36,0.20)' }}>
            <div className="flex items-center justify-between mb-4">
              <h3 className="font-oranienbaum font-bold text-white text-lg">Nueva Regla de Conciliación</h3>
              <button onClick={() => setShowRuleModal(false)} className="text-white/40 hover:text-white transition-colors">
                <Icon name="X" size={18} />
              </button>
            </div>
            <div className="space-y-3">
              {[
                { label: 'Tipo de regla', type: 'select', options: reconRuleTypes?.map(r => r?.label) },
                { label: 'Condición', type: 'text', placeholder: 'Ej: contiene "PROVEEDOR X"' },
                { label: 'Acción', type: 'select', options: ['Asignar a proveedor', 'Asignar a cliente', 'Asignar a departamento', 'Ignorar movimiento'] },
                { label: 'Departamento', type: 'select', options: ['Sala de Corte', 'Distribución', 'Tienda General', 'Corporativo'] },
              ]?.map((field) => (
                <div key={field?.label}>
                  <label className="block font-oranienbaum text-white/50 text-xs mb-1">{field?.label}</label>
                  {field?.type === 'select' ? (
                    <select className="w-full px-3 py-2 rounded-xl text-xs font-oranienbaum text-white/70 outline-none"
                      style={{ background: 'rgba(255,255,255,0.06)', border: '1px solid rgba(255,255,255,0.12)' }}>
                      {field?.options?.map((o) => <option key={o} style={{ background: '#111' }}>{o}</option>)}
                    </select>
                  ) : (
                    <input type="text" placeholder={field?.placeholder}
                      className="w-full px-3 py-2 rounded-xl text-xs font-oranienbaum text-white/70 placeholder-white/25 outline-none"
                      style={{ background: 'rgba(255,255,255,0.06)', border: '1px solid rgba(255,255,255,0.12)' }} />
                  )}
                </div>
              ))}
            </div>
            <div className="flex gap-2 mt-5">
              <button onClick={() => setShowRuleModal(false)}
                className="flex-1 py-2 rounded-xl text-xs font-oranienbaum text-white/50 hover:text-white transition-colors"
                style={{ background: 'rgba(255,255,255,0.04)', border: '1px solid rgba(255,255,255,0.08)' }}>
                Cancelar
              </button>
              <button className="flex-1 py-2 rounded-xl text-xs font-oranienbaum font-semibold text-black"
                style={{ background: '#D6EF4E' }}>
                Guardar Regla
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default FinBancos;
